import mitt from 'mitt';

export const emitter = mitt();

export const DEFAULT_LANGUAGE = 'de-CH';
export const LANGUAGES = [
  { codes: [/de/i, /de-*/i], value: 'de-CH' },
  { codes: [/en/i, /en-*/i], value: 'en-CH' },
  { codes: [/fr/i, /fr-*/i], value: 'fr-CH' },
  { codes: [/it/i, /it-*/i], value: 'it-CH' },
];

export const CREATE_BOOKING_DATE_FORMAT = 'DD.MM.YYYY';
export const CREATE_BOOKING_TIME_FORMAT = 'HH:mm:ss.SSS';
export const TELLIQ_DATE_FORMAT = 'YYYY-MM-DD';
export const EXTENDED_TELLIQ_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:SS';

export const DEFAULT_LIMIT_PARAM = 200;
export const MIN_TIME_FRAME_IN_MINUTES = 1;

export enum BookingTimeDisplay {
  START,
  END,
  BOTH,
}
